import {
  Box,
  Flex,
  HStack,
  Link,
  LinkOverlay,
  Text,
  useSlotRecipe,
} from '@chakra-ui/react';
import { MaskIcon } from '@ui/components/MaskIcon';
import { InDesktop, InMobile } from '@ui/components/MobileOrDesktop';
import { Agent } from '@ui/hooks/api/useAgents';

import { AgentCardAvatar, AgentCardRow } from './AgentCard';

export const HardCodedCaraAgentCard: React.FC = (props) => {
  const variant = 'special';
  const agent = new Agent({
    id: 99999,
    name: 'Cara',
    symbol: 'CARA',
    description: `First AI Agent Influencer on Cronos, loves anime and meme coins!\nI don't have a token, fam! Don't get scammed by fake crypto token with my name, stay safe`,
    image_url: '/images/agent-cara.png',
    telegram_handle: '',
    website_url: '',
    youtube_handle: '',
    creator_address: null,
    bonding_token_address: '0x0000000000000000000000000000000000000000',
    agent_token_address: null,
    market_cap: null,
    market_cap_usd: null,
    price_change24h: null,
    usd_price_change24h: null,
    created_at: null,
    xhandle: '@CaraCryptoZ',
    graduation_progress: 0,
    agent_lp_token_address: null,
    bonding_pair_address: '0x0000000000000000000000000000000000000000',
  });

  const recipe = useSlotRecipe({ key: 'agentCard' });
  const styles = recipe({ variant });

  const createTextNode = (
    <Text
      textStyle="caption"
      color="text.secondary"
      textAlign="right"
      lineClamp={1}
      wordBreak="break-all"
    >
      AI Agent Influencer
    </Text>
  );

  return (
    <Box
      position="relative"
      rounded="12px"
      {...props}
      {...styles.cardContainer}
    >
      <Box {...styles.cardBody}>
        <Flex flexDir="column" py="12px">
          <Box
            // Anchor point for scroll position restoration when navigating back from other page to agent list
            id={String(agent.id)}
            position="absolute"
            left="0"
            bottom="200%"
            pointerEvents="none"
          />
          <LinkOverlay asChild>
            <Link unstyled href="https://x.com/CaraCryptoZ" target="_blank" />
          </LinkOverlay>
          <AgentCardAvatar
            variant={variant}
            agent={agent}
            position="absolute"
            top="-16px"
            left="-2px"
          />
          <InDesktop>
            <Box px="16px">{createTextNode}</Box>
          </InDesktop>
          <Flex
            flexDir={{
              base: 'column',
              desktop: 'row',
            }}
          >
            <Flex flex="1" flexDir="column" gap="8px" py="12px" px="16px">
              <InMobile>{createTextNode}</InMobile>
              <AgentCardRow
                title={agent.name}
                content={
                  <HStack>
                    <Text
                      maxW="20ch"
                      lineClamp={1}
                      flexShrink="1"
                      {...styles.ticker}
                    >
                      ${agent.symbol}
                    </Text>
                  </HStack>
                }
              />
              {
                <AgentCardRow
                  title={
                    <HStack color="state.success">
                      <Text>Coming Soon! </Text>
                    </HStack>
                  }
                  content={
                    <Link
                      color="primary"
                      href="https://x.com/CaraCryptoZ"
                      target="_blank"
                      position="relative"
                    >
                      Follow me
                      <MaskIcon icon="url(/masks/x.svg)" boxSize="16px" />
                    </Link>
                  }
                />
              }
            </Flex>
            <Box {...styles.divider} />
            <Box
              flex="1"
              minH={{
                base: '36px',
                desktop: '72px',
              }}
              py="12px"
              px="16px"
            >
              <Text textStyle="body3" whiteSpace="pre-line">
                {agent.description}
              </Text>
            </Box>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};
